const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/config/basland/setup.ts';
/**
 * Times for schedule "schema"
 */
export const administrationBySchemaTimes = {
    Mo: '8:00',
    Mi: '12:00',
    Ab: '18:00',
    Na: '22:00',
};
